
import SearchPage from "../Components/SearchPage.jsx";

import "../App.css";

export default function Forecast() {
  return (
    <div>
      <h1> Find the weather  </h1>
      <SearchPage />
    </div>
  );
}
